export const VAN_PROGRAM = 'program:immunization'
export const VAN_SERVICE = 'program:immunization:service:immunization'
export const SL_SERVICE = 'program:shelflife:service:pharmaceuticals'
